/**
 * Created by sdielmann on 30.11.2017.
 */
import { Component, HostBinding, HostListener, Inject, Input } from '@angular/core';
import { MuiAccordionProvider } from './mui-accordion.component';

@Component({
  selector: 'mui-accordion-header',
  styleUrls: ['./mui-accordion-header.component.scss'],
  template: `
    <ng-content></ng-content>
    <div class="mui-accordion__header-chevron" *ngIf="!hideChevron" [class]="{ expanded: parent.expanded }" role="presentation">
      <i class="fal fa-chevron-down"></i>
    </div>
  `
})
export class MuiAccordionHeader {

  @Input() hideChevron = false;

  @HostBinding('attr.id')
  get id(): string {
    return `${this.parent.id}_header`;
  }

  @HostBinding('attr.role')
  readonly role = 'button';

  @HostBinding('attr.aria-controls')
  protected get ariaControls(): string {
    return `${this.parent.id}_content`;
  }

  constructor(@Inject(MuiAccordionProvider) public parent: MuiAccordionProvider) {}

  @HostListener('click') onClick() {
    this.parent.toggleExpandedState();
  }
}
